import React from "react"
import notAvailableImg from "../../assets/img/assessmentImages/notAvailable.svg"

export const AssessmentNotAvailable = ({ showAssessmentNotAvailable }) => {

    return (
        <div style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: "auto",
            height: "100vh",
            visibility: showAssessmentNotAvailable ? "visible" : "hidden"
        }}>
            <img src={notAvailableImg} />
        </div>
    )

}